import * as Yup from 'yup'

export const EmployeeValidationScheme = Yup.object().shape({
	email: Yup.string().email('invalid_email').required('required'),
	officePhone: Yup.string().nullable(),
	officePhoneInternal: Yup.string().nullable(),
	mobilePhone: Yup.string().nullable()
})
